module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "icon fa fa-arrow-left",
    staticStyle: {
      "margin-top": "25px",
      "margin-bottom": "25px"
    },
    style: (_vm.customStyle),
    on: {
      "click": function($event) {
        return _vm.goBack(_vm.returnUrl)
      }
    }
  }, [(_vm.backLabel) ? _c('span', {
    staticClass: "ml-1 backLabel",
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.bck')))]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-800e1f14", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-800e1f14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/backButton.vue
// module id = 2475
// module chunks = 2